module.exports = __webpack_public_path__ + "static/media/online-cove.375f73fa.png";